var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Usuarios","subtitle":"Lista de usuarios","fields":_vm.fields,"items":_vm.$store.state.users.users},on:{"delete":function($event){return _vm.deleteItem($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }